module.exports = __webpack_public_path__ + "img/text-vorkasse.8d2d0365.png";